module.exports = __webpack_public_path__ + "28f24bb7f17c6526526225a83d201068.svg";